import { render, staticRenderFns } from "./CompaniesList.vue?vue&type=template&id=00cf9b2a&scoped=true&"
import script from "./CompaniesList.vue?vue&type=script&lang=ts&"
export * from "./CompaniesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cf9b2a",
  null
  
)

export default component.exports